<template>
	<div class="form__group">
		<multiselect :options="options" :placeholder="placeholder" :allow-empty="allowEmpty" label="label" track-by="id"
		             :multiple="multiple" :searchable="false" :show-labels="false" v-model="selected"
		             :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">>
		</multiselect>

		<label class="form__label">Report Type</label>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'FormControlReportType',
		mixins: [Select],
		props: {
			resource: {
				type: String,
				required: true,
			}
		},
		data() {
			let options = [];

			switch(this.resource) {
				case 'opportunities' :
					options = [
						{
							label: 'Responses',
							id: 1,
						},
                        {
							label: 'Requests',
							id: 2,
						},
						{
							label: 'Opportunities by member sector',
							id: 3,
						},
						{
							label: 'Opportunities by member role',
							id: 4,
						},
						{
							label: 'Opportunities by region',
							id: 7,
						},
						{
							label: 'Opportunities by year',
							id: 10,
						},
						{
							label: 'Monthly Opportunities by role',
							id: 11,
						},
					];
					break;

				case 'madds' :
					options = [
						{
							label: 'MADDs by member sector',
							id: 5,
						},
						{
							label: 'MADDs by member role',
							id: 6,
						},
						{
							label: 'MADDs by region',
							id: 8,
						},
						{
							label: 'MADDs by year',
							id: 9,
						},
						{
							label: 'Monthly MADDs by role',
							id: 12,
						},
					];
					break;
			}

			return {
				options,
			}
		},
	}
</script>

